import gql from 'graphql-tag'

import {
  genericLink,
  locales,
  seo
} from '../utils'

export const page = `
  ... on afterSalesSupport_Entry {
    ${locales}
    ${seo}
    title
    description
    tab1Title
    tab1Description
    tab2Title
    tab2Description
    tab3Title
    tab3Description
    bottomAbstract: abstract
    bottomLink: ${genericLink}
  }
`

export const AFTERSALES_SUPPORT = gql`
  query AFTERSALES_SUPPORT($site: [String]) {
    page: entry(section: "afterSalesSupport", site: $site) {
      ${page}
    }
  }
`
